// extracted by mini-css-extract-plugin
module.exports = {"icon":"TreeSelector_icon__HJh5c","group":"TreeSelector_group__Virb4","item":"TreeSelector_item__2Y79Y"};